/* eslint-disable camelcase */
export const relayManager = {
    title: "Relay Manager",
    relay_count_one: "{{ count }} relay",
    relay_count_other: "{{ count }} relays",
    expand_all: "Expand all",
    collapse_all: "Collapse all",
    open_map: "Open map",
    no_relays: "No relays available.",
    no_relay_days: "No relay days available.",
    loading_relay_data: "Loading relay data",
    excluded: "Excluded",
    create_relay_failed: "Failed to create the relay. Please try again.",
    save_relay_failed: "Failed to save the relay. Please try again.",
    column_headers: {
        name: "Name",
        stages: "Stages",
    },
    context_menu: {
        edit_relay: "Edit relay",
        edit_permissions: "Edit permissions",
        add_day: "Add day",
        add_stream: "Add convoy",
        add_day_plan: "Add day plan",
        edit_day: "Edit day",
        edit_stream: "Edit convoy",
        edit_day_plan: "Edit day plan",
    },
    editors: {
        new_relay: "New Relay",
        edit_relay: "Edit Relay",
        new_day: "New Day",
        edit_day: "Edit Day",
        new_day_plan: "New Day Plan",
        edit_day_plan: "Edit Day Plan",
        new_stream: "New Convoy",
        edit_stream: "Edit Convoy",
        name: "Name",
        date: "Date",
        order: "Order",
        saving: "Saving...",
        relay_details: "Relay Details",
        relay_name_placeholder: "Relay name",
        start_date: "Start Date",
        end_date: "End Date",
        date_order_error: "Start date must be before end date",
        max_days_error: "Date range cannot exceed {{ max }} days",
        max_days_helper: "Maximum {{ max }} days",
        date_range_error: "Date must be between {{ min }} and {{ max }}",
        incomplete_config: "Complete every timetable configuration field, or clear them all, before saving.",
    },
    timetable: {
        configuration: "Timetable Configuration",
        data_fields: "Data Fields",
        route_types: "Route Types",
        stream_root_templates: "Convoy Root Layer Templates",
        stage_templates: "Stage Layer Templates",
        route_speed_list: "Route Speed List",
        transfer_speed_list: "Transfer Speed List",
        segment_children: "Segment Children",
        segment_children_need_templates: "Select a line template and a point template for the stages to allow segment children.",
        add_segment_child: "Add segment child",
        remove_segment_child: "Remove segment child",
        segment_child_labels: {
            child: "Child Template",
            parent: "Parent Template",
        },
        load_layer_templates_error: "Failed to load layer templates.",
        load_data_fields_error: "Failed to load data fields.",
        load_list_items_error: "Failed to load list items.",
        data_field_labels: {
            custom_speed: "Custom Speed",
            duration: "Duration",
            duration_buffer: "Duration Buffer",
            auto_calculate_start_time: "Auto Calculate Start Time",
            start_time: "Start Time",
            route_type: "Route Type",
            segment_order: "Segment Order",
            notes: "Notes",
            segment_child: "Segment Child",
        },
        route_type_labels: {
            convoy_and_torch: "Convoy and Torch",
            torch_only: "Torch Only",
            convoy_only: "Convoy Only",
        },
        speed_list_labels: {
            speed_value_property: "Speed Value Property",
            custom_speed_item: "Custom Speed Item",
            route_time_item: "Route Time Item",
            custom_duration_item: "Custom Duration Item",
        },
        selects: {
            select_label: "Select {{ label }}",
            select_templates: "Select templates",
            more_count: "+{{ count }} more",
        },
    },
} as const;
